import React             from 'react';
import classNames        from 'classnames';
import LocaleString      from '../../shared/locale-string';
import formatDate        from '../../../utils/format-date';
import Back              from '../../shared/back';
import Calendar          from '../../shared/calendar';
import ActivityIndicator from '../../shared/activity-indicator/activity-indicator.jsx';
import {
    CaretDownIcon,
    ArrowRightAltIcon,
    ArrowLeftAltIcon,
    CloseCircleIcon,
    CloseIcon
} from '../../shared';

import './activity-history.scss';

class AccountHistory extends React.Component {
    UNSAFE_componentWillMount() {//eslint-disable-line
        const {
            locale,
            userName,
            fetchData
        } = this.props;

        fetchData( userName, locale );
    }

    getClassNameForColumn = columnName => {
        const { sortedColumn, sortedColumnOrder } = this.props;

        if ( columnName === sortedColumn ) {
            return ( sortedColumnOrder === 'asc' ) ? 'sorted-on' : 'sorted-on desc';
        }
    };

    generatePageNumberList() {
        const list = [];
        for( let i = 1; i <= this.props.totalPages; i++ ) {
            list.push( i );
        }
        return list;
    }

    handleDates = ( value ) => {
        let {
            startDate,
            endDate
        } = this.props;

        if ( startDate && !endDate ) {
            if ( value < startDate ) {
                endDate = startDate;
                startDate = value;
            } else {
                endDate = value;
            }
        } else {
            startDate = value;
            endDate = null;
        }

        this.props.fetchDates( startDate, endDate );
    };

    handleHasActivity = ( fromDate, toDate ) => {
        const {
            actualData
        } = this.props;

        return actualData.find( ( item ) => item.date >= fromDate && item.date <= toDate ) !== undefined;
    };

    clearStartDate = () => {
        let { endDate } = this.props;
        let startDate;

        if ( endDate ) {
            startDate = endDate;
            endDate = null;
        } else {
            startDate = null;
        }

        this.props.fetchDates( startDate, endDate );
    };

    clearEndDate = () => {
        this.props.fetchDates( this.props.startDate, null );
    };

    render() {
        const {
            busyFetchingAccountHistory,
            currentPageActivityHistoryData,
            currentPage,
            totalPages,
            actualData,
            handleSort,
            handlePageNavigation,
            accountNumber,
            locale,
            startDate,
            endDate,
            unavailable
        } = this.props;

        const canNavigateToPreviousPage = currentPage != 1;
        const canNavigateToNextPage = currentPage != totalPages;

        return (
            <div id="activity-history-container" className="content-container activity-history-container">
                <div className="title" >
                    <Back className="back">
                        <CloseCircleIcon />
                    </Back>
                    <h1><LocaleString code="activityHistory.page.header" /></h1>
                </div>

                {
                    busyFetchingAccountHistory ?
                        <ActivityIndicator visible={ busyFetchingAccountHistory } />
                    : unavailable ?
                        <LocaleString className="no-activity" code="activityHistory.content.unavailableMessage" />
                    : !accountNumber ?
                        <LocaleString className="no-activity" code="activityHistory.content.noActivityMessage" />
                    :
                        <div>
                            {
                                accountNumber &&
                                <div className="left-section">
                                    <div className="account-number">
                                        <h3 htmlFor="accountNumber"><LocaleString code="activityHistory.form.accountNumberLabel" /></h3>
                                        <p>{ accountNumber }</p>
                                    </div>

                                    { actualData.length > 0 &&
                                    <div className="date-container" aria-live="polite">
                                        <div className="date">
                                            <h5><LocaleString code="activityHistory.form.fromLabel" /></h5>
                                            <p>
                                                { startDate && formatDate( startDate, locale ) }
                                                { startDate && <button className="close" aria-label="Clear date" onClick={ this.clearStartDate } ><CloseIcon /></button> }
                                            </p>
                                        </div>
                                        <div className="date">
                                            <h5><LocaleString code="activityHistory.form.toLabel" /></h5>
                                            <p aria-label={ !endDate && 'Not Set' } >
                                                { endDate && formatDate( endDate, locale ) }
                                                { endDate && <button className="close" aria-label="Clear date" onClick={ this.clearEndDate } ><CloseIcon /></button> }
                                            </p>
                                        </div>
                                    </div>
                                    }

                                    { actualData.length > 0 &&
                                    <div className="calendar-container">
                                        <Calendar locale={ locale } value={ startDate } fromValue={ startDate } toValue={ endDate }
                                                  onChange={ this.handleDates } hasActivity={ this.handleHasActivity } />
                                    </div>
                                    }
                                </div>
                            }

                            <div className="clear"></div>

                            <div className="right-section">
                                {
                                    actualData.length <= 0 ?
                                        <LocaleString className="no-activity" code="activityHistory.content.noActivityMessage" />
                                    : currentPageActivityHistoryData ?
                                        <div>
                                            <table>
                                                <thead>
                                                <tr>
                                                    <th className={ this.getClassNameForColumn( 'date' ) } scope="col">
                                                        <button onClick={ () => { handleSort( 'date' ); } }>
                                                            <LocaleString code="activityHistory.column.dateLabel" />
                                                            <div className="icon"><CaretDownIcon /></div>
                                                            <span className="sr-only">Sort on this column</span>
                                                        </button>
                                                    </th>
                                                    <th className={ this.getClassNameForColumn( 'description' ) } scope="col">
                                                        <button onClick={ () => { handleSort( 'description' ); } }>
                                                            <LocaleString code="activityHistory.column.descriptionLabel" />
                                                            <div className="icon"><CaretDownIcon /></div>
                                                            <span className="sr-only">Sort on this column</span>
                                                        </button>
                                                    </th>
                                                    <th className={ this.getClassNameForColumn( 'amount' ) } scope="col">
                                                        <button onClick={ () => { handleSort( 'amount' ); } }>
                                                            <LocaleString code="activityHistory.column.amountLabel" />
                                                            <div className="icon"><CaretDownIcon /></div>
                                                            <span className="sr-only">Sort on this column</span>
                                                        </button>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    currentPageActivityHistoryData.map( ( row, i ) => {
                                                        return (
                                                            <tr key={ i }>
                                                                <th scope="row" className="row-header">{ formatDate( row.date, locale ) }</th>
                                                                <td>{ row.description }</td>
                                                                <td>{ row.amountOrAward }</td>
                                                            </tr>
                                                        );
                                                    } )
                                                }
                                                </tbody>
                                            </table>

                                            { this.props.totalPages > 1 &&
                                                <div className="activity-history-footer">
                                                    <a
                                                        className={ classNames( {
                                                            'left-arrow': true,
                                                            'disabled': !canNavigateToPreviousPage
                                                        } ) }
                                                        onClick={ () => canNavigateToPreviousPage && handlePageNavigation( currentPage - 1 ) }
                                                        disabled={ !canNavigateToPreviousPage }>
                                                        <ArrowLeftAltIcon/>
                                                    </a>
                                                    <div>
                                                        {
                                                            this.generatePageNumberList()
                                                                .map( ( p ) => ( <a
                                                                    key={ p }
                                                                    className={ `activity-history-page ${ currentPage === p ? 'active-page' : '' }` }
                                                                    onClick={ ( ) => handlePageNavigation( p ) }>
                                                                    { p }
                                                                </a> ) )
                                                        }
                                                    </div>
                                                    <a
                                                        className={ classNames( {
                                                            'right-arrow': true,
                                                            'disabled': !canNavigateToNextPage
                                                        } ) }
                                                        onClick={ ( ) => canNavigateToNextPage && handlePageNavigation( currentPage + 1 ) }
                                                        disabled={ !canNavigateToNextPage }>
                                                        <ArrowRightAltIcon/>
                                                    </a>
                                                </div>
                                            }
                                        </div>
                                        : endDate === null ?
                                            <LocaleString className="no-activity"
                                                code="activityHistory.content.noActivityMessageOn" replaceOptions={ {
                                                startDate: formatDate( startDate, locale )
                                            } } />
                                        :
                                            <LocaleString className="no-activity"
                                                code="activityHistory.content.noActivityMessageBetween" replaceOptions={ {
                                                startDate: formatDate( startDate, locale ),
                                                endDate: formatDate( endDate, locale )
                                            } } />
                                }
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default AccountHistory;


